import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Ajv from 'ajv';
import addFormats from 'ajv-formats';
import adapt from "./adapt";
import unflatList from "./unflatList";
import flatList from "./flatList";
import mappedRequired from "./mappedRequired";
import { execute } from "./sandboxCode";
export const errorMessages = {
  required: 'cfm_label_required_field',
  minLength: 'cfm_label_error_minlength',
  maxLength: 'cfm_label_error_maxlength',
  type: 'cfm_label_error_type',
  maximum: 'cfm_error_max_num',
  minimum: 'cfm_error_min_num',
  exclusiveMaximum: 'cfm_label_error_exclusivemaximum',
  exclusiveMinimum: 'cfm_label_error_exclusiveminimum',
  maxItems: 'cfm_label_error_maxitems',
  minItems: 'cfm_label_error_minitems'
};
function isValidCustomError(error) {
  if (!error || typeof error !== 'object') return false;
  return !Object.keys(error).find(key => typeof error[key] !== 'object' || typeof error[key] === 'object' && !error[key].message);
}
function executeCustomValidations(validations, data, errors, schema) {
  return new Promise((resolve, reject) => {
    const validationPrs = validations.filter(validation => validation.event === 'onSubmit').map(validation => execute(validation.code, {
      data,
      errors,
      schema
    }));
    if (validationPrs && validationPrs.length) {
      Promise.all(validationPrs).then(errors => {
        let finalErrors = errors.reduce((obj, error) => {
          if (isValidCustomError(error)) obj = _objectSpread(_objectSpread({}, obj), error);
          return obj;
        }, {});
        resolve(finalErrors);
      }).catch(error => {
        reject({
          message: 'Custom validations failed',
          error
        });
      });
    } else resolve({});
  });
}
function getVisibleFields(composition, visibleFields) {
  return composition.reduce((vf, el) => {
    var _el$composition;
    if ((_el$composition = el.composition) !== null && _el$composition !== void 0 && _el$composition.length && !el.isHidden) return getVisibleFields(el.composition, [...vf, el.schemaId]);
    if (!el.isHidden) return [...vf, el.schemaId];
    return vf;
  }, visibleFields);
}
const adaptWithUndefineds = data => {
  return Object.keys(data).reduce((newData, key) => {
    if (data[key] === null || data[key] === '') newData[key] = undefined;else newData[key] = data[key];
    return newData;
  }, {});
};
function flatSchema(composition, sortedErrorFields) {
  return composition.reduce((arr, el) => {
    var _el$composition2;
    if ((_el$composition2 = el.composition) !== null && _el$composition2 !== void 0 && _el$composition2.length) return [...arr, ...flatSchema(el.composition, sortedErrorFields)];
    return [...arr, el.schemaId || el.id];
  }, sortedErrorFields);
}
export default (data, schema, isBulk, noUnflat) => {
  return new Promise(resolve => {
    var _schema$required, _document$querySelect, _schema$context, _schema$context$objec;
    let errors = {};
    const ajv = new Ajv({
      verbose: true,
      removeAdditional: true,
      useDefaults: true,
      coerceTypes: true,
      allErrors: true,
      strict: false
    });
    addFormats(ajv);

    // We should apply required validation to empty strings too

    let cleanData = adapt(data, schema);
    cleanData = flatList(cleanData, schema);
    const visibleFields = getVisibleFields(schema.layout.composition, []);
    const bulkEdited = Object.keys(data);
    const cleanSchema = _objectSpread({}, schema);
    cleanSchema.required = [...((schema === null || schema === void 0 ? void 0 : (_schema$required = schema.required) === null || _schema$required === void 0 ? void 0 : _schema$required.filter(el => (visibleFields === null || visibleFields === void 0 ? void 0 : visibleFields.includes(el)) && (!isBulk || bulkEdited.includes(el)))) || []), ...mappedRequired(schema.layout)];
    const finalDataUndefineds = adaptWithUndefineds(cleanData);
    const isValid = ajv.validate(cleanSchema, finalDataUndefineds);
    if (!isValid) {
      ajv.errors.forEach(error => {
        const errorKeyword = error.keyword;
        let key = error.schemaPath.split('/')[2];
        if (!key) key = error.params.missingProperty;
        errors[key] = {
          message: errorMessages[errorKeyword] || errorKeyword,
          params: Array.isArray(error.schema) ? error.schema : [error.schema],
          error
        };
      });
    }
    if (!noUnflat) cleanData = unflatList(data, cleanData, schema);
    const sortedErrorFields = flatSchema(schema.layout.composition, []).filter(el => errors[el]);
    (_document$querySelect = document.querySelector(`.fs-form__field__${sortedErrorFields[0]}`)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    let result = {
      isValid,
      errors,
      cleanData
    };
    if (schema !== null && schema !== void 0 && (_schema$context = schema.context) !== null && _schema$context !== void 0 && (_schema$context$objec = _schema$context.object) !== null && _schema$context$objec !== void 0 && _schema$context$objec.validations) {
      var _schema$context2, _schema$context2$obje;
      executeCustomValidations(schema === null || schema === void 0 ? void 0 : (_schema$context2 = schema.context) === null || _schema$context2 === void 0 ? void 0 : (_schema$context2$obje = _schema$context2.object) === null || _schema$context2$obje === void 0 ? void 0 : _schema$context2$obje.validations, cleanData, errors, schema).then(errors => {
        result.errors = _objectSpread(_objectSpread({}, result.errors), errors);
        resolve(result);
      }).catch(err => {
        console.error('Execute custom validations', err);
        resolve(result);
      });
    } else resolve(result);
  });
};